import { LYNX_CONNECT } from '../actionTypes';

export const fetchInvoices = (action) => ({
  type: LYNX_CONNECT.FETCH_INVOICE,
  payload: action.payload,
});

export const fetchInvoiceMeta = (action) => ({
  type: LYNX_CONNECT.FETCH_META,
  payload: action.payload,
});

export const addNewInvoice = (action) => ({
  type: LYNX_CONNECT.ADD_NEW_INVOICE,
  payload: action.payload,
});

export const fetchLocations = (action) => ({
  type: LYNX_CONNECT.FETCH_LOCATIONS,
  payload: action.payload,
});

export const addNewLocation = (action) => ({
  type: LYNX_CONNECT.ADD_NEW_LOCATION,
  payload: action.payload,
});

export const setAddNewInvoiceStatus = (action) => ({
  type: LYNX_CONNECT.SET_INVOICE_NEW_STATUS,
  payload: action.payload,
});

export const fetchValidate = (action) => ({
  type: LYNX_CONNECT.FETCH_VALIDATE,
  payload: action.payload,
});

export const validateUpdateAll = (action) => ({
  type: LYNX_CONNECT.VALIDATE_UPDATE_ALL,
  payload: action.payload,
});

export const validateEditRowSync = (action) => ({
  type: LYNX_CONNECT.VALIDATE_EDIT_ROW_SYNC,
  payload: action.payload,
});

export const validateEditRowSyncStatus = (action) => ({
  type: LYNX_CONNECT.SET_VALIDATE_EDIT_ROW_SYNC_STATUS,
  payload: action.payload,
});

export const validateRowSync = (action) => ({
  type: LYNX_CONNECT.VALIDATE_ROW_SYNC,
  payload: action.payload,
});

export const validateSetTableData = (action) => ({
  type: LYNX_CONNECT.SET_VALIDATE_CONTENT,
  payload: action.payload,
});

export const fetchExist = (action) => ({
  type: LYNX_CONNECT.FETCH_EXIST,
  payload: action.payload,
});

export const fetchExistHistory = (action) => ({
  type: LYNX_CONNECT.FETCH_EXIST_HISTORY,
  payload: action.payload,
});

export const existUpdateAll = (action) => ({
  type: LYNX_CONNECT.EXIST_UPDATE_ALL,
  payload: action.payload,
});

export const existEditRowSync = (action) => ({
  type: LYNX_CONNECT.EXIST_EDIT_ROW_SYNC,
  payload: action.payload,
});

export const existEditRowSyncStatus = (action) => ({
  type: LYNX_CONNECT.SET_EXIST_EDIT_ROW_SYNC_STATUS,
  payload: action.payload,
});

export const existSingleLineItemValue = (action) => ({
  type: LYNX_CONNECT.SET_EXIST_SINGLE_LINE_ITEM_VALUE,
  payload: action.payload,
});

export const existSetTableData = (action) => ({
  type: LYNX_CONNECT.SET_EXIST_CONTENT,
  payload: action.payload,
});

export const existRowSync = (action) => ({
  type: LYNX_CONNECT.EXIST_ROW_SYNC,
  payload: action.payload,
});

export const existUpdatePos = (action) => ({
  type: LYNX_CONNECT.EXIST_UPDATE_POS,
  payload: action.payload,
});

export const resetValidateLineItems = (action) => ({
  type: LYNX_CONNECT.RESET_VALIDATE_LINE_ITEMS,
  payload: action.payload,
});

export const resetExistLineItems = (action) => ({
  type: LYNX_CONNECT.RESET_EXIST_LINE_ITEMS,
  payload: action.payload,
});

export const resetLocations = (action) => ({
  type: LYNX_CONNECT.RESET_LOCATIONS,
  payload: action.payload,
});

export const resetInvoices = (action) => ({
  type: LYNX_CONNECT.RESET_INVOICES,
  payload: action.payload,
});

export const setPosStatus = (action) => ({
  type: LYNX_CONNECT.EXIST_UPDATE_POS_STATUS,
  payload: action.payload,
});

export const setInvoicePdf = (action) => ({
  type: LYNX_CONNECT.SET_INVOICE_PDF,
  payload: action.payload,
});

export const setLoading = (action) => ({
  type: LYNX_CONNECT.SET_MAIN_LOADING,
  payload: action.payload,
});

export const fetchInvoiceDetail = (action) => ({
  type: LYNX_CONNECT.FETCH_INVOICE_DETAIL,
  payload: action.payload,
});

export const fetchInvoicePdf = (action) => ({
  type: LYNX_CONNECT.FETCH_INVOICE_PDF,
  payload: action.payload,
});

export const fetchAutditLog = (action) => ({
  type: LYNX_CONNECT.FETCH_AUDIT_LOG,
  payload: action.payload,
});

export const requestApproval = (action) => ({
  type: LYNX_CONNECT.REQUEST_APPROVAL,
  payload: action.payload,
});

export const setAuditEvent = (action) => ({
  type: LYNX_CONNECT.SET_AUDIT_EVENT,
  payload: action.payload,
});

export const setExistLineItemTotalElements = (action) => ({
  type: LYNX_CONNECT.SET_EXIST_CONTENT_TOTAL_ELEMENTS,
  payload: action.payload,
});

export const setValidateLineItemTotalElements = (action) => ({
  type: LYNX_CONNECT.SET_VALIDATE_TOTAL_ELEMENTS,
  payload: action.payload,
});
